// After logout the tenant SPA must leave via a real document load so the
// RadioCloud gateway can serve its login page. Client-side routing to /login
// keeps RadioSuiteX mounted. replace() to the current path can also be a no-op
// (dashboard is `/`), so reload in that case.

export function postLogoutPath(behindGateway) {
  return behindGateway ? '/' : '/login';
}

export function hardNavigate(dest, locationLike = typeof window !== 'undefined' ? window.location : null) {
  if (!locationLike) return 'noop';
  const path = dest === '/' || dest === '' ? '/' : dest;
  const current = locationLike.pathname || '/';
  if (current === path) {
    locationLike.reload();
    return 'reload';
  }
  locationLike.replace(path);
  return 'replace';
}
